<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">AI视频</div>
    </div>
    <div class="page-body">
      <div class="table">
        <div class="tableItem">
          <div class="tableItemFirst" @click="goToPage('videoText')">
            <div class="tableItemTitle">视频创作</div>
            <!-- <div class="tableItemMessage">选好脚本与形象，AI自动剪辑</div> -->
          </div>
          <div class="tableItemSecond">
            <div class="tableItemSecondItemOne" @click="goToPage('bestseller')">
              <div class="tableItemTitle">爆款跟拍</div>
              <!-- <div class="tableItemMessage">一键复用爆款视频</div> -->
            </div>
            <div
              class="tableItemSecondItemTwo"
              @click="goToPage('customAvatar')"
            >
              <div class="tableItemTitle">我的形象</div>
              <!-- <div class="tableItemMessage">人像+人声的管理</div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="centerTable">
        <div
          class="centerTableItem"
          :class="
            centerTableActive == item.code ? 'centerTableItem_active' : ''
          "
          v-for="(item, index) in centerTableList"
          :key="index"
          @click="changeItem(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="history-content-box" ref="contentBox">
        <!-- 有数据时显示列表 -->

        <div v-if="videoList.length > 0 && centerTableActive == 1">
          <div class="record-list">
            <div
              class="record-item"
              v-for="(item, index) in videoList"
              :key="index"
              @click="goCreationDetail(item)"
            >
              <div
                v-if="item.createStatus == 1 || item.createStatus == 3"
                class="record-itemError"
              >
                <img
                  :src="item.createStatus == 3 ? errorImg : failImg"
                  alt="#"
                  class="record-itemErrorImg"
                  :class="item.createStatus == 3 ? 'errorImg' : 'failImg'"
                />
                <div class="record-itemErrorTitle">
                  {{ item.createStatus == 3 ? "生成失败" : "视频生成中..." }}
                </div>
              </div>
              <div v-else>
                <div class="videoTime">
                  {{ formattedTime(item.videoTime) }}
                </div>
                <img
                  :src="item.fileImageUrl"
                  alt="#"
                  class="record-item-img"
                  v-if="item.fileImageUrl"
                />
              </div>
            </div>
            <div
              v-for="i in placeholderCount"
              :key="'placeholder-' + i"
              class="zwDiv"
            ></div>
          </div>
          <div
            class="load-tip"
            v-if="
              centerTableActive === 1 && !videoHasMore && videoList.length > 0
            "
          >
            没有更多数据了
          </div>
        </div>

        <div v-else-if="textList.length > 0 && centerTableActive == 2">
          <div class="text-list-container">
            <!-- 遍历对象数组，item是包含title/content的完整对象 -->
            <div
              class="text-item"
              v-for="(item, index) in textList"
              :key="index"
            >
              <div class="text-itemNewOne" @click="goConfirm(item)">
                <div>
                  <div class="text-itemNewOneTitle">
                    {{ item.text || "无标题" }}
                  </div>
                  <div class="text-itemNewTwo">
                    <div>字数：{{ item.num }}</div>
                    <div>时间：{{ item.duration }}</div>
                    <div>{{ formatDateToYmd(item.createTime) || "" }}</div>
                  </div>
                </div>
                <div @click.stop="deleteItem(item)">
                  <img
                    src="@/assets//aiVideo/delete.svg"
                    alt="#"
                    class="deleteImg"
                  />
                </div>
              </div>
              <!-- 显示title，添加点击事件并传入当前item -->
              <!-- <div class="text-content" @click="goNoteDetail(item)">
                {{ item.title || "无标题" }}
              </div> -->
              <!-- <div></div> -->
            </div>
          </div>
          <div
            class="load-tip"
            v-if="
              centerTableActive === 2 && !noteHasMore && textList.length > 0
            "
          >
            没有更多数据了
          </div>
        </div>
        <div class="load-tip" v-else-if="isLoading">加载中...</div>

        <!-- 无数据时显示空状态（通过height:100%居中） -->
        <div class="empty-state" v-else>
          <img src="@/assets/nodata.png" class="empty-img" />
          <div class="empty-text">暂无记录</div>
        </div>
      </div>
    </div>
    <div v-if="showDeleteModal" class="modal-overlay" @click="closeDeleteModal">
      <div class="modal-content" @click.stop>
        <div class="modal-title">提示</div>
        <div class="modal-body">
          <div class="modal-text">确定要删除此脚本吗</div>
        </div>
        <div class="modal-confirm-div">
          <div class="modal-confirm-btn" @click="closeDeleteModal">取消</div>
          <div class="modal-confirm-btn-ff" @click="confirmDelete">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageTalkingVideo, scriptPageList, scriptDelete } from "@/api";
// 在 script 顶部导入图片
import errorImg from "@/assets/aiVideo/error.png";
import failImg from "@/assets/aiVideo/underway.png";

export default {
  name: "aiVideo",
  data() {
    return {
      errorImg,
      failImg,
      // 分页配置
      pageSize: 20, // 每页条数
      // AI海报分页
      videoPageNumber: 1,
      videoHasMore: true,
      // AI笔记分页
      notePageNumber: 1,
      noteHasMore: true,
      // AI视频分页（暂不处理）
      // 列表数据
      videoList: [],
      textList: [],
      // 加载状态（防止重复请求）
      isLoading: false,
      title: "",
      content: "",
      vipType: "",
      showVipTipModal: false,
      centerTableActive: 1,
      centerTableList: [
        { code: 1, name: "创作记录" },
        { code: 2, name: "我的脚本" },
      ],
      showDeleteModal: false, // 控制删除弹窗显示
      currentDeleteItem: null, // 存储当前要删除的脚本项
	  currentPlatform: '',
    };
  },

  computed: {
    placeholderCount() {
      const remainder = this.videoList.length;
      return (3 - (remainder % 3)) % 3; // 当余数为0时返回0，避免多添加占位元素
    },
  },
  mounted() {
    this.gethistoryImg();
    this.listenScroll();
	this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
	document.title = "AI视频";
  },
  methods: {
    async deleteItem(item) {
      this.currentDeleteItem = item; // 保存当前要删除的项
      this.showDeleteModal = true; // 显示弹窗
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.currentDeleteItem = null; // 清空当前项
    },

    // 新增：确认删除逻辑
    async confirmDelete() {
      if (!this.currentDeleteItem) return;
      try {
        // 调用删除接口（假设item有id字段，接口参数为id）
        await scriptDelete({ id: this.currentDeleteItem.id });
        this.$toast && this.$toast("删除成功");
        // 关闭弹窗
        this.closeDeleteModal();
        // 重新拉取脚本列表（刷新数据）
        this.textList = [];
        this.notePageNumber = 1;
        this.noteHasMore = true;
        this.gethistoryNote();
      } catch (error) {
        this.$toast && this.$toast("删除失败，请重试");
        this.closeDeleteModal();
      }
    },
    goConfirm(item) {
      this.$router.push({
        path: "videoTextconfirm",
        query: {
          content: item.text, // 携带输入框/选题的content
        },
      });
    },
    formatDateToYmd(dateStr) {
      // 先去除首尾空格，避免输入有多余空格导致匹配失败
      const trimmedStr = (dateStr || "").trim();
      if (!trimmedStr) {
        return null;
      }

      // 正则匹配 yyyy-mm-dd 格式（年份4位，月份和日期2位）
      const ymdRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (ymdRegex.test(trimmedStr)) {
        // 已经是目标格式，直接返回
        return trimmedStr;
      }

      try {
        // 解析ISO格式的日期字符串
        const date = new Date(trimmedStr);
        // 检查日期是否有效（Invalid Date的getTime()会返回NaN）
        if (isNaN(date.getTime())) {
          throw new Error("无法解析为有效的日期");
        }

        // 提取年、月、日并补零（确保月份和日期是两位数）
        const year = date.getFullYear();
        // 月份是0开始的，所以要+1
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        // 拼接成yyyy-mm-dd格式
        return `${year}-${month}-${day}`;
      } catch (error) {
        return null;
      }
    },
    formattedTime(value) {
      const minutes = Math.floor(value / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (value % 60).toString().padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
    // 返回按钮逻辑
    onBack() {
      this.$router.push({ path: "home" });
    },
    async goToPage(item) {
      if (item) {
        sessionStorage.setItem("formPage", "aiVideo");
        if (item == "customAvatar") {
          // let data = await markCountAvatar();
          // if (data) {
          this.$router.push({
            path: "myFigure",
          });
          // } else {
          //   this.$router.push({
          //     path: "customAvatar",
          //     query: { formPath: "aiVideo" },
          //   });
          // }
        } else {
          this.$router.push({
            path: item,
          });
        }
      } else {
        this.$toast && this.$toast("请期待");
      }
    },
    changeItem(item) {
      this.centerTableActive = item.code;
      // 重置加载状态
      this.isLoading = false;
      // 根据选项重置对应数据和分页
      switch (item.code) {
        case 1: // AI海报
          this.videoList = [];
          this.videoPageNumber = 1;
          this.videoHasMore = true;
          this.gethistoryImg(); // 重新拉取第一页
          break;
        case 2: // AI笔记
          this.textList = [];
          this.notePageNumber = 1;
          this.noteHasMore = true;
          this.gethistoryNote(); // 重新拉取第一页
          break;
      }
    },
    loadMore() {
      // 正在加载/无更多数据，直接返回
      if (this.isLoading) return;
      switch (this.centerTableActive) {
        case 1:
          if (this.videoHasMore) {
            this.videoPageNumber++;
            this.gethistoryImg();
          }
          break;
        case 2:
          if (this.noteHasMore) {
            this.notePageNumber++;
            this.gethistoryNote();
          }
          break;
      }
    },

    // 5. 监听滚动到底部
    listenScroll() {
      const contentBox = this.$refs.contentBox;
      if (!contentBox) return;
      contentBox.addEventListener("scroll", () => {
        // 滚动到底部的判断：滚动高度 + 可视高度 >= 总高度 - 100（提前加载）
        const { scrollTop, clientHeight, scrollHeight } = contentBox;
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          this.loadMore();
        }
      });
    },
    // 计算需要多少个占位 div

    async gethistoryImg() {
      if (!this.videoHasMore || this.isLoading) return;
      this.isLoading = true;
      try {
        const data = await pageTalkingVideo({
          pageNum: this.videoPageNumber,
          pageSize: this.pageSize,
        });
        // 关键：获取总条数 + 兜底
        const totalRow = data?.totalRow || 0;
        if (data && Array.isArray(data.records)) {
          // 拼接数据
          if (this.videoPageNumber === 1) {
            this.videoList = data.records;
          } else {
            this.videoList = [...this.videoList, ...data.records];
          }
          // 新判断逻辑：已加载数量 < 总条数 → 还有更多
          this.videoHasMore = this.videoList.length < totalRow;
        } else {
          this.videoHasMore = false;
        }
      } catch (error) {
        this.videoHasMore = false;
      } finally {
        this.isLoading = false;
      }
    },
    async gethistoryNote() {
      if (!this.noteHasMore || this.isLoading) return;
      this.isLoading = true;
      try {
        const data = await scriptPageList({
          pageNumber: this.notePageNumber,
          pageSize: this.pageSize,
        });
        // 关键：获取总条数 + 兜底
        const totalRow = data?.totalRow || 0;
        if (data && Array.isArray(data.records)) {
          // 拼接数据
          if (this.notePageNumber === 1) {
            this.textList = data.records;
          } else {
            this.textList = [...this.textList, ...data.records];
          }
          // 新判断逻辑：已加载数量 < 总条数 → 还有更多
          this.noteHasMore = this.textList.length < totalRow;
        } else {
          this.noteHasMore = false;
        }
      } catch (error) {
        this.noteHasMore = false;
      } finally {
        this.isLoading = false;
      }
    },
    goCreationDetail(item) {
      if (item.createStatus != 2) return;
      sessionStorage.setItem("formPage", "aiVideo");

      this.$router.push({
        path: "creationDetail",
        query: {
          id: item.id,
          formPath: "aiVideo",
        },
      });
    },
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
.page-body {
}
.table {
  padding: 5.333vw 5.8666vw;
  /* display: flex;
  align-items: center;
  justify-content: space-around; */
}
.tableItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tableItemFirst {
  width: 42.666vw;
  height: 32vw;
  background-image: url("../../assets/aiVideo/spcz.png"); /* 背景图片路径 */
  background-repeat: no-repeat; /* 不重复 */
  background-position: center center; /* 居中显示 */
  background-size: cover; /* 覆盖整个容器（保持比例） */
}
.tableItemSecond {
  display: flex;
  flex-direction: column;
  height: 32vw;
  justify-content: space-between;
}
.tableItemSecondItemOne {
  width: 42.666vw;
  height: 14.666vw;
  background-image: url("../../assets/aiVideo/bkgp.png"); /* 背景图片路径 */
  background-repeat: no-repeat; /* 不重复 */
  background-position: center center; /* 居中显示 */
  background-size: cover; /* 覆盖整个容器（保持比例） */
}
.tableItemSecondItemTwo {
  width: 42.666vw;
  height: 14.666vw;
  background-image: url("../../assets/aiVideo/wdxx.png"); /* 背景图片路径 */
  background-repeat: no-repeat; /* 不重复 */
  background-position: center center; /* 居中显示 */
  background-size: cover; /* 覆盖整个容器（保持比例） */
}
.tableItemTitle {
  /* opacity: 0.8; */
  color: #17204d;
  font-weight: 500;
  font-size: 3.7333vw;
  line-height: 5.4666vw;
  padding: 2.666vw 0 0 2.4vw;
}
.tableItemMessage {
  opacity: 0.4;
  font-family: SourceHanSansSC-regular;
  color: #333333;
  font-weight: 400;
  font-size: 2.9333vw;
  line-height: 4.4vw;
  padding-left: 2.4vw;
  max-width: 36.266vw;
}
.centerTable {
  display: flex;
  align-items: center;
  margin: 0 4.2666vw;
  border-bottom: 0.2666vw solid #e4e8ec;
  padding-bottom: 2.1333vw;
}
.centerTableItem {
  color: #666666;
  font-weight: 500;
  font-size: 3.7333vw;
  height: 5.4666vw;
  line-height: 5.4666vw;
}
.centerTableItem_active {
  /* opacity: 0.9; */
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  height: 6.2666vw;
  line-height: 6.2666vw;
}
.centerTable > .centerTableItem:first-child {
  margin-right: 4.2666vw;
}
.history-content-box {
  /* margin-top: 5.3333vw; */
  margin-top: 3.2vw;
  width: 100%;
  height: calc(100vh - 70.5332vw);
  height: calc(100dvh - 70.5332vw);
  /* flex: 1; */
  box-sizing: border-box;
  overflow-y: auto;
  /* 仅此处纵向滚动 */
  overflow-x: hidden;
  /* 禁止横向滚动 */
  padding-bottom: 2vw;
  /* 底部留白优化体验 */
  /* 移除居中样式（有数据时不需要居中，空状态单独处理） */
  display: block;
  -webkit-overflow-scrolling: touch;
  /* 保留移动端弹性滚动 */
  scrollbar-width: none;
  /* Firefox 隐藏滚动条 */
  -ms-overflow-style: none;
  /* IE/Edge 隐藏滚动条 */
}

.history-content-box::-webkit-scrollbar {
  display: none;
  /* 隐藏滚动条 */
  width: 0;
  height: 0;
}

.history-content-box::-webkit-scrollbar-track {
  background: transparent;
}

.history-content-box::-webkit-scrollbar-thumb {
  background: transparent;
}

/* 无数据状态容器 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  /* 撑满content-box高度实现居中 */
}

/* 无数据图片样式 */
.empty-img {
  width: 26.6667vw;
  /* 200px = 200/7.5 = 26.6667vw */
  height: 21.3333vw;
  /* 160px = 160/7.5 = 21.3333vw */
  object-fit: contain;
  /* 保持图片比例 */
}

/* 无数据文字样式 */
.empty-text {
  margin-top: 4.2667vw;
  /* 32px = 32/7.5 = 4.2667vw */
  font-family: SourceHanSansSC-Regular;
  font-size: 3.2vw;
  /* 24px = 24/7.5 = 3.2vw */
  color: #c2c2c2;
  text-align: center;
  font-weight: 400;
}

.record-list {
  /* width: calc(100vw - 8.5334vw); */
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  justify-content: space-around;
  /* 横向等分间距 */
  box-sizing: border-box;
  padding-left: 6.666vw;
  padding-right: 6.666vw;
}

/* 单个记录项容器 */
.record-item {
  background-color: #f0f4f8;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  width: 25.6vw;
  height: 48vw;
  margin-bottom: 3.2vw;
  flex-shrink: 0;
  /* 24px = 24/7.5 = 3.2vw */
  box-sizing: border-box;
  border-radius: 2.1333vw;
  position: relative;
}
.record-item-img {
  width: 25.6vw;
  height: 48vw;
  border-radius: 2.1333vw;
  object-fit: cover;
}
.videoTime {
  position: absolute;
  left: 1.6vw;
  bottom: 0.8vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 2.666vw;
  line-height: 3.8666vw;
}
.zwDiv {
  width: 25.6vw;
}
/* 记录项内图片 */
.record-img {
  width: 100%;
  /* 宽度占满容器 */
  height: 100%;
  /* 高度自适应（这里用100%撑满容器，也可写auto） */
  object-fit: contain;
  /* 保持图片比例，不拉伸 */
  display: block;
  /* 去除图片默认间隙 */
}

.text-list-container {
  width: 100%;
  box-sizing: border-box;
  /* 每个item之间的间距 */
  display: flex;
  flex-direction: column;
  /* gap: 2.6667vw; */
  padding: 0 4.2666vw;
  /* 20px = 20/7.5，item之间上下间距 */
}

/* 单个文字字符串容器 */
.text-item {
  width: 100%;
  /* 宽度占满 */
  height: auto;
  background-color: rgba(240, 244, 248, 0.6);
  box-shadow: 0px 0.2667vw 0px 0px rgba(234, 236, 241, 1);
  /* -2px = -0.2667vw */
  box-sizing: border-box;
  padding: 2.133vw 4.1333vw 2.133vw 3.2vw;
  margin-bottom: 2.133vw;
}

/* 文字内容样式 */
.text-content {
  opacity: 0.8;
  font-family: SourceHanSansSC-regular;
  color: #333333;
  font-weight: 400;
  font-size: 2.9333vw;
  /* 22px = 22/7.5 */
  font-style: normal;
  text-decoration: none;
  text-align: left;
  line-height: 1.5;
  /* 增加行高，提升可读性 */
  word-wrap: break-word;
  /* 自动换行 */
  word-break: break-all;
  /* 兼容长字符串换行 */
}

.load-tip {
  text-align: center;
  padding: 2.6667vw 0;
  font-size: 2.6667vw;
  color: #999;
}
.record-itemError {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.record-itemErrorImg {
}
.record-itemErrorTitle {
  height: 4.4vw;
  color: #1f2226;
  font-weight: 500;
  font-size: 2.9333vw;
}
.text-itemNewOne {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-itemNewOneTitle {
  width: 77.6vw;
  height: 4.8vw;
  color: #000000;
  font-weight: 500;
  font-size: 3.2vw;
  line-height: 4.8vw;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏溢出 */
  text-overflow: ellipsis;
}
.text-itemNewTwo {
  display: flex;
  align-items: center;
  margin-top: 1.4666vw;
  height: 4.4vw;
  color: #666666;
  font-weight: 400;
  font-size: 2.9333vw;
  line-height: 4.4vw;
}
.text-itemNewTwo > div {
  margin-right: 3.733vw;
}
.deleteImg {
  width: 4.2666vw;
  height: 4.2666vw;
}
.errorImg {
  width: 11.4613vw;
  height: 12.429vw;
  margin-bottom: 2.8vw;
}
.failImg {
  width: 9.39vw;
  height: 10.6453vw;
  margin-bottom: 6.4vw;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  width: 80vw;
  border-radius: 3.2vw;
  background-color: #ffffff;
}

.modal-title {
  line-height: 6.2666vw;
  color: #666666;
  font-weight: 500;
  font-size: 4.2666vw;
  text-align: center;
  padding: 5.333vw 0 4.2666vw 0;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.modal-text {
  width: 67.2vw;
  color: #666666;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 1.0666vw;
  text-align: center;
}

.modal-confirm-div {
  display: flex;
  justify-content: center;
  margin-top: 6.5333vw;
  margin-bottom: 5.333vw;
}
.modal-confirm-btn {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  line-height: 10.666vw;
  opacity: 0.8;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
  margin-right: 5.333vw;
}
.modal-confirm-btn-ff {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  line-height: 10.666vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
}
</style>
